// services/refundService.js
import axios from 'axios';
import Api from '../api/ApiUrl'
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const API_URL = `${Api}/api/v1`;
export const getRefundRequests = async () => {
  const response = await axios.get(`${API_URL}/refund-requests`,config);
  console.log(response?.data?.data)
  return response?.data?.data?.data;
};
export const getRefundRequestspending = async () => {
  const response = await axios.get(`${API_URL}/refund-requests?status=pending`,config);
  console.log(response?.data?.data)
  return response?.data?.data?.data;
};
export const getallnotifications = async () => {
  const response = await axios.get(`${API_URL}/admin-notifications?seen=false`,config);
  console.log(response?.data?.data)
  return response?.data?.data?.data;
};
export const getRefundRequestById = async (id) => {
  const response = await axios.get(`${API_URL}/refund-requests/${id}`,config);
  console.log(response)
  return response.data.data;
};

export const updateRefundRequestStatus = async ({id,status}) => {
  console.log(id)
  console.log(status)

  const response = await axios.patch(`${API_URL}/refund-requests/${id}`,{status},config);
  return response.data.data.refundRequest;
};

export const deleteRefundRequest = async (id) => {
  
  const response = await axios.delete(`${API_URL}/refund-requests/${id}`,config);
  return response.data;
};
